// extracted by mini-css-extract-plugin
export default {"customLabel":"LeaveStatisticsPerTeam_customLabel__0hp9D","filterMarginTop":"LeaveStatisticsPerTeam_filterMarginTop__zmJLl"};